import { useEffect } from "react";

export const useEscapePress = (onPress: () => void) => {
    useEffect(() => {
        const escPress = (event: KeyboardEvent) => {
            if (event.key === "Escape") {
                onPress();
            }
        };

        document.addEventListener("keydown", escPress);

        return () => {
            document.removeEventListener("keydown", escPress);
        };
    }, [onPress]);
};
